const defaultErrorMessage = "Něco se pokazilo";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApiErrorMessage = (e: any): string => {
  console.error("Api error:", e.response?.data || e.response || e);

  // Todo: use e.response?.data?.DisplayMessage. Blocked by https://github.com/mild-blue/health-warden/issues/86
  return e.response?.data?.message ?? defaultErrorMessage;
};
